import { render, staticRenderFns } from "./burningMatterDetails.vue?vue&type=template&id=30ac1130&"
import script from "./burningMatterDetails.vue?vue&type=script&lang=js&"
export * from "./burningMatterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports